module.exports = __webpack_public_path__ + "static/img/download.6fd54d69.png";